import { FC } from "react";
import ReactSkeleton, { SkeletonProps } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Skeleton: FC<SkeletonProps> = ({
  count,
  wrapper: Wrapper,
  className: customClassName,
  containerClassName,
  containerTestId,
  circle,
  style: styleProp,
  ...propsStyleOptions
}) => (
  <ReactSkeleton
    count={count}
    wrapper={Wrapper}
    className={customClassName}
    containerClassName={containerClassName}
    containerTestId={containerTestId}
    circle={circle}
    style={styleProp}
    {...propsStyleOptions}
  />
);

export default Skeleton;
